module.exports = __webpack_public_path__ + "static/images/containers/BuildingCard/components/ReserveProduce/images/divider-shadowed-mask.74f71462.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingCard/components/ReserveProduce/images/divider-shadowed-mask.png
// module id = 2803
// module chunks = 11